const handleHorizontalScroll = (e, sectionElement) => {
    if (e.matches) {
        const sectionRect = sectionElement.getBoundingClientRect();
        console.log(sectionElement.getBoundingClientRect());
        if (sectionRect.x > 24) {
            const parentElement = sectionElement.parentElement;
            if (parentElement) {
                const scrollLeft = sectionRect.x - 24;
                parentElement.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        }
    }
};
export const scrollToSection = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const sectionId = urlParams.get('section');
    if (sectionId) {
        const sectionElement = document.getElementById(sectionId);
        if (sectionElement) {
            const headerElement = document.querySelector('header');
            const headerOffset = headerElement ? headerElement.offsetHeight : 0;
            const elementPosition = sectionElement.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: 'smooth'
            });
            const mediaQuery = window.matchMedia('(max-width: 768px)');
            handleHorizontalScroll(mediaQuery, sectionElement);
            mediaQuery.addEventListener('change', (e) => handleHorizontalScroll(e, sectionElement));
        }
    }
};
